import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconPromotionalEmail = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <path
          d="M10.9987 14.6271H3.63506C3.55469 14.6271 3.47762 14.5952 3.42079 14.5384C3.36396 14.4815 3.33203 14.4044 3.33203 14.3241V5.96953C3.33203 5.88917 3.36396 5.81209 3.42079 5.75526C3.47762 5.69843 3.55469 5.6665 3.63506 5.6665H16.3623C16.4427 5.6665 16.5198 5.69843 16.5766 5.75526C16.6334 5.81209 16.6654 5.88917 16.6654 5.96953V9.33317"
          stroke="#2F393E"
          strokeWidth="0.842105"
        />
        <path
          d="M16.3749 5.6665H3.72033C3.69552 5.6666 3.67133 5.67432 3.65104 5.68861C3.63075 5.70289 3.61533 5.72306 3.60687 5.7464C3.59841 5.76973 3.59732 5.79509 3.60373 5.81906C3.61015 5.84304 3.62377 5.86446 3.64276 5.88044L9.78458 11.0532C9.80601 11.0711 9.83298 11.0811 9.86092 11.0814C9.88886 11.0817 9.91606 11.0724 9.93791 11.055L16.4494 5.88287C16.4692 5.86729 16.4836 5.84597 16.4906 5.82185C16.4977 5.79773 16.4971 5.772 16.4889 5.74823C16.4807 5.72446 16.4654 5.70383 16.4449 5.68919C16.4245 5.67454 16.4 5.66662 16.3749 5.6665Z"
          stroke="#2F393E"
          strokeWidth="0.842105"
        />
        <path
          d="M16.7999 13V15.6667H12.5332V13"
          stroke="#FF9D28"
          strokeWidth="0.589474"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3333 11.667H12V13.0003H17.3333V11.667Z"
          stroke="#FF9D28"
          strokeWidth="0.589474"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.668 15.667V11.667"
          stroke="#FF9D28"
          strokeWidth="0.589474"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6674 11.6668H13.4674C13.2906 11.6668 13.1211 11.5966 12.996 11.4716C12.871 11.3465 12.8008 11.177 12.8008 11.0002C12.8008 10.8234 12.871 10.6538 12.996 10.5288C13.1211 10.4037 13.2906 10.3335 13.4674 10.3335C14.4008 10.3335 14.6674 11.6668 14.6674 11.6668Z"
          stroke="#FF9D28"
          strokeWidth="0.589474"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.668 11.6668H15.868C16.0448 11.6668 16.2143 11.5966 16.3394 11.4716C16.4644 11.3465 16.5346 11.177 16.5346 11.0002C16.5346 10.8234 16.4644 10.6538 16.3394 10.5288C16.2143 10.4037 16.0448 10.3335 15.868 10.3335C14.9346 10.3335 14.668 11.6668 14.668 11.6668Z"
          stroke="#FF9D28"
          strokeWidth="0.589474"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
